import type { StatusCampaignPayloadBuilderState } from '~/utils/societePayloadBuilder/statusCampaign/types';

export interface PayloadFormSectionProps {
  state: StatusCampaignPayloadBuilderState;
  onChange: (next: StatusCampaignPayloadBuilderState) => void;
}

export function updatePayloadState(
  state: StatusCampaignPayloadBuilderState,
  onChange: (next: StatusCampaignPayloadBuilderState) => void,
  patch: Partial<StatusCampaignPayloadBuilderState>,
) {
  onChange({ ...state, ...patch });
}
